module.exports = __webpack_public_path__ + "assets/comment.235080e2.svg";